import { request } from "@umijs/max";
import { AliOssConfig, ApiResponse } from "../common";
import {
  ConfigDetailResult,
  EnumConfigResult,
  LoginParams,
  LoginResult,
  RoutersResult,
  UserInfoResult,
} from "./types";

/**
 * 登录
 * POST /exam-api/login
 * */
export async function login(
  body: LoginParams,
  options?: { [key: string]: any }
): Promise<LoginResult> {
  return request<LoginResult>("/exam-api/login", {
    method: "POST",
    data: body,
    skipAuth: true, // 登录接口不需要携带token
    ...(options || {}),
  });
}

/**
 * 获取菜单列表
 * GET /exam-api/getRoutes
 * */
export async function getRoutes(params: {
  roleId: number;
}): Promise<RoutersResult> {
  return request<RoutersResult>("/exam-api/getRoutes", {
    method: "GET",
    params: params,
  });
}

/**
 * 用户详情
 * GET /exam-api/sys/users/info
 * */
export async function getUsersInfo(): Promise<UserInfoResult> {
  return request<UserInfoResult>("/exam-api/sys/users/info", {
    method: "GET",
  });
}

/**
 * 登录用户修改基础信息
 * PUT /exam-api/sys/users/modifyUser
 * */
export async function updateModifyUser(body: {
  password?: string;
  nickname?: string;
}): Promise<ApiResponse<string>> {
  return request<ApiResponse<string>>("/exam-api/sys/users/modifyUser", {
    method: "PUT",
    data: body,
  });
}

/**
 * 退出登录
 * GET /exam-api/logout
 * */
export async function logout(): Promise<ApiResponse<string>> {
  return request<ApiResponse<string>>("/exam-api/logout", {
    method: "GET",
  });
}

/**
 * 发送短信验证码
 * POST /exam-api/sendSmsCode
 * */
export async function sendSmsCode(body: {
  phone: string;
  codeType: number;
}): Promise<ApiResponse<string>> {
  return request<ApiResponse<string>>("/exam-api/sendSmsCode", {
    method: "POST",
    data: body,
    skipAuth: true, // 登录接口不需要携带token
  });
}

/**
 * 获取阿里云OSS的stsToken和v4Policy
 * GET /exam-api/getOSSUploadSts
 * */
export async function getOSSUploadSts(params: {
  withV4Policy: number;
}): Promise<ApiResponse<AliOssConfig>> {
  return request<ApiResponse<AliOssConfig>>("/exam-api/getOSSUploadSts", {
    method: "GET",
    params: params,
  });
}

/**
 * 系统配置接口
 * GET /exam-api/getConfig
 * */
export async function getConfig(): Promise<ConfigDetailResult> {
  return request<ConfigDetailResult>("/exam-api/getConfig", {
    method: "GET",
  });
}

/**
 * 系统配置接口
 * GET /exam-api/getEnumConfig
 * */
export async function getEnumConfig(params: {
  collectName: string;
}): Promise<EnumConfigResult> {
  return request<EnumConfigResult>("/exam-api/getEnumConfig", {
    method: "GET",
    params: params,
  });
}
